<app-navbar-one></app-navbar-one>

<div class="page-title-area item-bg-4">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Services Details</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Services Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-video">
            <div class="details-image">
               
            </div>
            <div class="details-video">
                <video width="800" height="480" controls style="width: 100%;">
                    <source src="/assets/img/services-details/Presentacion.mp4" type="video/mp4">
                    Tu navegador no admite el elemento de video.
                  </video>             
            </div>
            <div class="text">

                <h3>We Provide Useful Services</h3>
                <p> 

                    Unlock the full potential of your online presence with our comprehensive digital marketing services. We specialize in:
                    
                    Social Media Management: We craft engaging social media strategies to connect with your audience, boost brand awareness, and increase conversions.
                    
                    PPC (Pay-Per-Click) Advertising: Maximize your ROI with targeted ad campaigns that bring quality traffic to your website.
                    
                    Search Engine Optimization (SEO): Improve your website's visibility on search engines, increasing organic traffic and driving long-term growth.
                    
                    Email Marketing: Build and nurture valuable relationships with your customers through personalized email campaigns.
                    </p>
            </div>
        </div>
        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-desc">
                        <h3>Design and Branding</h3>
                        <p>
                            First impressions matter. Our design and branding services are designed to help you make a lasting impact:

Logo Design: We create a unique and memorable brand identity that reflects your business.

Packaging Design: Stand out on the shelves and attract customers with innovative packaging designs that captivate.

Graphic Design: From brochures to digital banners, our designs engage your audience and leave a strong impression.

Website Development: Your website is the face of your business in the digital world. We build stunning and functional websites:

Website Design and Development: We create customized websites that are user-friendly and visually appealing.

E-commerce Solutions: Increase your online sales with powerful e-commerce platforms and seamless user experiences.

Mobile Optimization: Ensure your website is responsive and accessible on all devices.

App Development: In an increasingly mobile-driven world, our app development services help you reach your audience on the go:

Custom Software Solutions: We create tailored software that addresses your unique business needs and streamlines operations.

Why Choose Us?

Experienced Team: Our team comprises seasoned experts in marketing, design, and digital development.

Customized Solutions: We don't believe in a one-size-fits-all approach. Every project is unique, and our solutions adapt to your specific needs.

Results-Oriented: Our primary focus is delivering measurable results that drive your business forward.

Customer-Centric: Your success is our success. We work closely with you to achieve your goals.

Innovation: We stay at the forefront of the latest industry trends and technologies."
                            </p>
                        <div class="features-text">
                            <h4>    </h4>
                            <p> 
                                </p>
                        </div>
                        <div class="features-text">
                            <h4>   </h4>
                            <p>
                                </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="assets/img/services-details/redes1.jpg" alt="image">
                    </div>
                </div>
            </div>
        </div>
        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-image">
                        <img src="assets/img/services-details/brand1.jpg" alt="image">
                    </div>
                </div>
                
            </div>
        </div>   
    </div>
</section>